<template>
  <div id="app">
    <a-locale-provider :locale="locale">
      <router-view></router-view>
    </a-locale-provider>
  </div>
</template>

<script>
// import {Button} from 'ant-design-vue'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
export default {
  name: 'App',
  components: {},
  data() {
    return {
      locale: zhCN,
    }
  },
  methods: {}
}
</script>

<style lang="less" scoped>
::v-deep .ant-pagination {
  text-align: center;
}
</style>
